/// <amd-module name="TFS/TeamProfilePanel/MembersTab" />
import * as React from "react";
import * as Resources from "TFS/TeamProfilePanel/Resources";
import { PersonaDetailsProvider } from "VSS/Features/Identities/PersonaDetailsProvider";
import { TeamMember } from "VSS/Platform/Contracts/WebApi";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { ScrollableList } from "VSSUI/List";
import { Observer } from "VSSUI/Observer";
import { IBasicIdentityRef, Persona, PersonaSize } from "VSSUI/Persona";
import { Pill } from "VSSUI/Pill";
import { Spinner, SpinnerSize } from "VSSUI/Spinner";
import { ITeamProfilePanelService } from "./TeamProfilePanelService";

export interface IMembersTabProps {
    teamId: string;
}

export class MembersTab extends VssComponent<IMembersTabProps> {
    private personaProvider: PersonaDetailsProvider;
    private teamProfilePanelSvc: ITeamProfilePanelService;

    constructor(props: IMembersTabProps, context: IVssComponentContext) {
        super(props, context);

        this.personaProvider = new PersonaDetailsProvider(context.pageContext);
        this.teamProfilePanelSvc = context.pageContext.getService<ITeamProfilePanelService>("ITeamProfilePanelService");
    }

    public render() {
        const { teamId } = this.props;
        return (
            <Observer isLoading={this.teamProfilePanelSvc.getIsLoadingItems()}>
                {(props: { isLoading: boolean }) => {
                    return props.isLoading ? (
                        <Spinner className="flex flex-center" size={SpinnerSize.large} label={Resources.Loading} />
                    ) : (
                        <ScrollableList
                            ariaLabel={Resources.Members}
                            className="content-row margin-top-8"
                            itemProvider={this.teamProfilePanelSvc.getMemberProvider(teamId)}
                            renderRow={this.renderListRow}
                        />
                    );
                }}
            </Observer>
        );
    }

    private renderListRow = (rowIndex: number, member: TeamMember) => {
        const identity = {
            id: member.identity.id,
            displayName: member.identity.displayName,
            imageUrl: member.identity.imageUrl
        } as IBasicIdentityRef;
        return (
            <div
                className="item-panel-row flex-center flex-row margin-top-8 padding-left-8 subtle-border"
                data-is-focusable={true}
                aria-label={Resources.Members}
            >
                <Persona size={PersonaSize.size40} identity={identity} personaProvider={this.personaProvider} />
                <div className="margin-left-16">{member.identity.displayName}</div>
                {member.isTeamAdmin && (
                    <div className="margin-left-16">
                        <Pill className="pill-position">{Resources.Admin}</Pill>
                    </div>
                )}
            </div>
        );
    };
}
